import styled from '@emotion/styled';

export const Cell = styled.div`
  box-sizing: border-box;
  padding: 10px;
`;

export const TextCell = styled(Cell)`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DoubleCell = styled(Cell)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
`;
